import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import es from "./locales/es.json";
import en from "./locales/en.json";
import pt from "./locales/pt.json";
import { auth, db } from "../firebase/firebaseConfig";
import { doc, setDoc } from "firebase/firestore";

// Obtener idioma guardado o usar español por defecto
const savedLanguage = localStorage.getItem("language") || "es";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
      pt: { translation: pt },
    },
    supportedLngs: ["es", "en", "pt"],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    keySeparator: ".",
    nsSeparator: ":",
    lng: savedLanguage,
    fallbackLng: "es",
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

// Guardar idioma cuando cambie
i18n.on("languageChanged", (lng) => {
  localStorage.setItem("language", lng);

  const uid = auth.currentUser?.uid;
  if (uid) {
    void setDoc(doc(db, 'users', uid), { language: lng }, { merge: true });
  }
});

export default i18n;
